module.exports = __webpack_public_path__ + "img/pr-2.c496712c.png";